import React, { useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
	searchMember,
	getPaymentTypes,
	savePayment,
} from "../../../../api/apiServices";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import toast, { Toaster } from "react-hot-toast";

const ManualReceipt = (props) => {
	const [isOpen, setIsOpen] = useState(false);

	const closeModal = () => setIsOpen(!isOpen);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/manual_receipt";

	const [search, setSearch] = useState(false);
	const [member, setMember] = useState([]);

	const [pf_number, setPFNumber] = useState(null);
	const [mobile_number, setMobileNumber] = useState(null);
	// const [first_name, setFirstName] = useState(null);
	// const [last_name, setLastName] = useState(null);

	const [payment_year, setPaymentYear] = useState("");
	const [payment_type, setPaymentType] = useState([]);
	const [payment_amount, setPaymentAmount] = useState("");
	const [payment_mode, setPaymentMode] = useState("");

	const year = 2018;
	const years = Array.from(new Array(20), (val, index) => index + year);

	const { data: payment_types } = useQuery("payment_types", getPaymentTypes);

	const searchMutation = useMutation(searchMember, {
		onSuccess: async (res) => {
			if (res.length > 0) {
				setMember(res);
				setSearch(true);
			}
			if (res.length <= 0) {
				setSearch(true);
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 3000,
			});
		},
	});

	const handleSearch = async (e) => {
		e.preventDefault();

		const searchData = {
			pf_number: pf_number,
			mobile_number: mobile_number,
			// first_name: first_name,
			// last_name: last_name,
		};
		searchMutation.mutate(searchData);
	};

	let member_id;
	let member_pf_number = "";
	let ledger_id;
	let ledgerYear = "";
	let ledgerData = [];
	for (var i = 0; i < member.length; i++) {
		member_id = member[i].id;
		member_pf_number = member[i].pf_number;
		ledger_id = member[i].ledgers[i].id;
		ledgerYear = member[i].ledgers[i].year;
	}

	member[0]?.ledgers?.map((ledg, index) => {
		ledgerData.push({
			id: index,
			year: ledg.year,
			pf_number: ledg.pf_number,
			transaction_date: ledg.transaction_date,
			opening_balance: ledg.opening_balance,
			expected_total_amount: ledg.expected_total_amount,
			total_amount_paid: ledg.total_amount_paid,
			closing_balance: ledg.closing_balance,
		});
	});

	const handleConfirm = (e) => {
		e.preventDefault();
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className="custom-ui">
						<div>
							<div style={{ textAlign: "center" }}>
								<h3>Payment Confirmation</h3>
							</div>
						</div>

						<table className="table table-borderless">
							{member.map((mem, index) => (
								<tbody>
									<tr key={index}>
										<td>Full Name</td>
										<td>
											{mem.title} {mem.first_name}{" "}
											{mem.middle_name} {mem.last_name}
										</td>
									</tr>
									<tr>
										<td>PF Number</td>
										<td>{mem.pf_number}</td>
									</tr>
									<tr>
										<td>Mobile Number</td>
										<td>{mem.mobile_number}</td>
									</tr>
									<tr>
										<td>Payment Year</td>
										<td>{payment_year}</td>
									</tr>
									<tr>
										<td>Payment Amount</td>
										<td>
											{payment_amount.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}
										</td>
									</tr>
									<tr>
										<td>Mode of Payment</td>
										<td>
											{payment_mode === "CC"
												? "CASH"
												: payment_mode === "QQ"
												? "CHEQUE"
												: payment_mode === "MM"
												? "CHEQUE"
												: payment_mode === "BD"
												? "CHEQUE"
												: payment_mode === "DD"
												? "CHEQUE"
												: "ONLINE"}
										</td>
									</tr>
								</tbody>
							))}
						</table>
						<br />
						<div>
							<button
								className="btn btn-danger"
								onClick={onClose}
							>
								{" "}
								Cancel
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<button
								onClick={() => {
									handleSubmit();
									onClose();
								}}
								className="btn btn-success"
							>
								Confirm
							</button>
						</div>
					</div>
				);
			},
		});
	};

	const handleSubmit = async (e) => {
		if (payment_year === "") {
			toast.warning("Payment Year is required");
			return false;
		} else if (payment_mode === "") {
			toast.warning("Payment mode is required");
			return false;
		} else if (payment_amount === "") {
			toast.warning("Payment amount is required");
			return false;
		} else {
			try {
				const data = {
					member_id: member_id,
					ledger_id: ledger_id,
					pf_number: member_pf_number,
					mobile_number: mobile_number,
					year: payment_year,
					payment_type: payment_type,
					payment_mode: payment_mode.toLocaleUpperCase(),
					payment_amount: parseFloat(payment_amount),
				};

				savePayment(data).then((res) => {
					toast.success("Member payment successfully received ");
					setPFNumber("");
					setMobileNumber("");
					// setFirstName("");
					// setLastName("");
					setPaymentYear("");
					setPaymentType("");
					setPaymentMode("");
					setPaymentAmount("");
					setSearch(false);
				});
				navigate(from, { replace: true });
			} catch (err) {
				if (err.response?.status === 400) {
					toast.error(err.response);
				} else if (err.response?.status === 401) {
					toast.error(err.response);
				} else {
					console.log(err);
				}
			}
		}
	};

	const handleCancel = () => {
		setSearch(false);
		setPFNumber("");
		setMobileNumber("");
		// setFirstName("");
		// setLastName("");
		navigate(from, { replace: true });
	};

	let searchContent = (
		<form onSubmit={handleSearch}>
			<div className="form-group row">
				<div className="col-sm-5">
					<input
						className="form-control"
						type="text"
						placeholder="PF Number"
						style={{ textTransform: "uppercase" }}
						onChange={(e) => setPFNumber(e.target.value)}
						value={pf_number}
					/>
				</div>
				<div className="col-sm-5">
					<input
						className="form-control"
						type="text"
						// style={{ textTransform: "uppercase" }}
						placeholder="Mobile Number"
						onChange={(e) => setMobileNumber(e.target.value)}
						value={mobile_number}
					/>
				</div>
				{/* <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="FirstName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={first_name}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="LastName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setLastName(e.target.value)}
                        value={last_name}
                    />
                </div> */}
				<button type="submit" className="btn btn-success ">
					{" "}
					<i className="fa fa-search"></i> Search Member
				</button>
			</div>
		</form>
	);

	const memberDetails =
		search && member?.length > 0 ? (
			<div className="panel-body">
				<legend>Personal Information</legend>
				<div className="table-responsive lg">
					<table className="table table-borderless">
						{member?.map((mem, index) => (
							<tbody>
								<tr key={index}>
									<td>NAME</td>
									<td
										style={{
											fontSize: "14px",
											fontWeight: "500",
											textAlign: "left",
											whiteSpace: "pre-wrap",
										}}
									>
										{" "}
										{mem.title} {mem.first_name}{" "}
										{mem.middle_name} {mem.last_name}
									</td>
									<td>VOTER ID</td>
									<td>
										<b>{mem?.voter_id_number}</b>
									</td>
								</tr>
								<tr>
									<td>PF NUMBER</td>
									<td
										style={{
											fontSize: "14px",
											fontWeight: "500",
											textAlign: "left",
											whiteSpace: "pre-wrap",
										}}
									>
										{" "}
										{mem.pf_number}
									</td>
									<td>REGION</td>
									<td>
										<b>{mem?.region}</b>
									</td>
								</tr>
								<tr>
									<td>MOBILE NUMBER</td>
									<td
										style={{
											fontSize: "14px",
											fontWeight: "500",
											textAlign: "left",
											whiteSpace: "pre-wrap",
										}}
									>
										{" "}
										{mem.mobile_number}
									</td>
									<td>DATE JOINED</td>
									<td>
										<b>{mem?.date_joined}</b>
									</td>
								</tr>
								<tr>
									<td>EMAIL ADDRESS</td>
									<td
										style={{
											fontSize: "14px",
											fontWeight: "500",
											textAlign: "left",
											whiteSpace: "pre-wrap",
										}}
									>
										{" "}
										{mem.email}
									</td>
									<td>PROFESSION</td>
									<td>
										<b>{mem?.profession}</b>
									</td>
								</tr>
							</tbody>
						))}
					</table>
				</div>
			</div>
		) : null;

	const legdgerInfo =
		search && member?.length > 0 ? (
			<>
				<legend>Ledger Account</legend>
				<div className="table-responsive lg">
					<table className="table table-borderless table-striped">
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Year</th>
								<th style={{ textAlign: "left" }}>
									Ledger Date
								</th>
								<th style={{ textAlign: "right" }}>
									Opening Balance
								</th>
								<th style={{ textAlign: "right" }}>
									Expected Payment
								</th>
								<th style={{ textAlign: "right" }}>
									Amount Paid
								</th>
								<th style={{ textAlign: "right" }}>
									Closing Balance{" "}
								</th>
							</tr>
						</thead>
						<tbody>
							{ledgerData?.map((ledger, index) => (
								<>
									<tr key={ledger.id}>
										<td style={{ textAlign: "center" }}>
											{ledger?.year}
										</td>
										<td style={{ textAlign: "left" }}>
											{ledger?.transaction_date}
										</td>
										{ledger?.opening_balance < 0 ? (
											<td style={{ textAlign: "right" }}>
												(
												{(
													ledger?.opening_balance * -1
												).toLocaleString(undefined, {
													minimumFractionDigits: 2,
												})}
												){" "}
											</td>
										) : (
											<td style={{ textAlign: "right" }}>
												{ledger?.opening_balance.toLocaleString(
													undefined,
													{ minimumFractionDigits: 2 }
												)}{" "}
											</td>
										)}
										{ledger?.expected_total_amount < 0 ? (
											<td style={{ textAlign: "right" }}>
												(
												{(
													ledger?.expected_total_amount *
													-1
												).toLocaleString(undefined, {
													minimumFractionDigits: 2,
												})}
												){" "}
											</td>
										) : (
											<td style={{ textAlign: "right" }}>
												{ledger?.expected_total_amount.toLocaleString(
													undefined,
													{ minimumFractionDigits: 2 }
												)}{" "}
											</td>
										)}
										<td style={{ textAlign: "right" }}>
											{ledger?.total_amount_paid.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
										{ledger?.closing_balance < 0 ? (
											<td style={{ textAlign: "right" }}>
												(
												{(
													ledger?.closing_balance * -1
												).toLocaleString(undefined, {
													minimumFractionDigits: 2,
												})}
												){" "}
											</td>
										) : (
											<td style={{ textAlign: "right" }}>
												{ledger?.closing_balance.toLocaleString(
													undefined,
													{ minimumFractionDigits: 2 }
												)}{" "}
											</td>
										)}
									</tr>
								</>
							))}
						</tbody>
					</table>
				</div>
			</>
		) : null;

	const paymentReceipt =
		search && member.length > 0 ? (
			<>
				<legend>Receive Payment</legend>
				<form onSubmit={handleConfirm}>
					<div className="form-group row">
						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label
									htmlFor="payment_year"
									className="col-sm-3"
								>
									Year
								</label>
								<div className="col-sm-9">
									<select
										type="text"
										id="payment_year"
										autoComplete="off"
										style={{ textTransform: "capitalize" }}
										onChange={(e) =>
											setPaymentYear(e.target.value)
										}
										required
										value={payment_year}
										name="payment_year"
										className="form-control"
									>
										<option>Select Year</option>
										{years.map((year, index) => (
											<option
												value={year}
												key={`year${index}`}
											>
												{year}
											</option>
										))}
									</select>
								</div>
							</div>

							<div className="form-group row">
								<label
									htmlFor="payment_type"
									className="col-sm-3"
								>
									Payment Type
								</label>
								<div className="col-sm-9">
									<select
										type="text"
										id="payment_type"
										autoComplete="off"
										style={{ textTransform: "capitalize" }}
										onChange={(e) =>
											setPaymentType(e.target.value)
										}
										// onChange={handlePaymentYear}
										required
										value={payment_type}
										name="payment_type"
										className="form-control"
									>
										<option>Select Payment Type</option>
										{payment_types?.map((payment_type) => (
											<option
												key={payment_type.id}
												value={payment_type.description}
											>
												{payment_type.description}
											</option>
										))}
									</select>
								</div>
							</div>
						</fieldset>

						<fieldset className="col-sm-6">
							<div className="form-group row">
								<label htmlFor="pf_number" className="col-sm-3">
									Payment Amount
								</label>
								<div className="col-sm-9">
									<input
										type="number"
										id="payment_amount"
										autoFocus
										autoComplete="off"
										onChange={(e) =>
											setPaymentAmount(e.target.value)
										}
										value={payment_amount}
										required
										name="payment_amount"
										className="form-control"
									/>
								</div>
							</div>

							<div className="form-group row">
								<label htmlFor="pf_number" className="col-sm-3">
									Payment Mode
								</label>
								<div className="col-sm-9">
									<select
										type="text"
										id="payment_mode"
										placeholder="payment_mode"
										autoComplete="off"
										style={{ textTransform: "capitalize" }}
										onChange={(e) =>
											setPaymentMode(e.target.value)
										}
										required
										value={payment_mode}
										name="payment_mode"
										className="form-control"
									>
										<option>Select Payment Mode</option>
										<option value="CC">CASH</option>
										<option value="QQ">CHEQUE</option>
										<option value="MM">MOMO</option>
										<option value="BD">BANK DRAFT</option>
										<option value="DD">DIRECT DEBIT</option>
									</select>
								</div>
							</div>
						</fieldset>
					</div>
					<div className="panel-footer">
						<div className="form-group row">
							<div className="col-sm-2">
								<button
									type="submit"
									className="btn btn-danger"
									onClick={handleCancel}
								>
									Cancel
								</button>
								&nbsp;&nbsp;&nbsp;&nbsp;
								<button className="btn btn-success">
									Submit
								</button>
							</div>
						</div>
					</div>
				</form>
			</>
		) : null;

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Manual Receipt of Payments</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											{searchContent}
										</h4>
									</div>
								</div>
							</div>
							{memberDetails}
							<div className="panel-body">{legdgerInfo}</div>
							<div className="panel-body">{paymentReceipt}</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
};

export default ManualReceipt;
